import { cn } from "@/lib/utils";
import { ReactNode } from "react";

import { dropdownArrow } from "../../../designSystemIcons";

// A Dropdown trigger; the Dropdown around it takes the click
type Props = {
  icon: ReactNode;
  isOpen: boolean;
  disabled?: boolean;
};

export const IconDropDown = ({ icon, isOpen, disabled }: Props) => {
  return (
    <button
      type="button"
      className={cn(
        "flex h-7 rounded-md border gap-x-0.5 px-1 transition-colors",
        disabled
          ? "cursor-not-allowed bg-disabled border-edge"
          : isOpen
            ? "bg-surface-raised border-edge-strongest"
            : "bg-surface border-edge-strong touch-device:hover:bg-surface-raised",
      )}
    >
      <div className="flex h-full">{icon}</div>
      <span
        className={cn(
          "my-auto -translate-y-0.5",
          isOpen && "rotate-180 pb-1.5",
          disabled ? "stroke-dark-disabled" : "stroke-white",
        )}
      >
        {dropdownArrow}
      </span>
    </button>
  );
};
